import React, { useState } from 'react';
import { G } from '../theme';
import { SKILLS } from '../data';

export default function SkillsModalitesTab() {
  const [tab, setTab] = useState("skills");
  const btnBase = { fontSize:14, fontWeight:600, padding:"10px 28px", borderRadius:8, cursor:"pointer", fontFamily:"inherit", border:"none", transition:"all 0.2s" };
  return (
    <div>
      {/* Toggle buttons */}
      <div className="lp-tab-btns" style={{ display:"inline-flex", background:"#fff", borderRadius:10, padding:4, border:"1px solid #E0E0D8", marginBottom:32, gap:4 }}>
        <button onClick={() => setTab("skills")} className="lp-tab-btn"
          style={{ ...btnBase, background: tab==="skills" ? G.g700 : "transparent", color: tab==="skills" ? "#fff" : G.gray6 }}>
          ✓ Compétences acquises
        </button>
        <button onClick={() => setTab("modalites")} className="lp-tab-btn"
          style={{ ...btnBase, background: tab==="modalites" ? G.g700 : "transparent", color: tab==="modalites" ? "#fff" : G.gray6 }}>
          📋 Modalités de formation
        </button>
      </div>

      {/* SKILLS panel */}
      {tab === "skills" && (
        <div>
          <h2 style={{ fontFamily:"'Playfair Display',serif", fontSize:"1.8rem", fontWeight:700, marginBottom:6, color:G.g900 }}>Compétences acquises</h2>
          <p style={{ color:G.g700, marginBottom:28, fontSize:15 }}>Immédiatement applicables sur le terrain</p>
          <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit,minmax(260px,1fr))", gap:14 }}>
            {SKILLS.map((s,i) => (
              <div key={i} style={{ display:"flex", alignItems:"flex-start", gap:12 }}>
                <div style={{ flexShrink:0, width:26, height:26, borderRadius:"50%", background:G.g700, display:"flex", alignItems:"center", justifyContent:"center", fontSize:13, color:"#fff", marginTop:1 }}>✓</div>
                <span style={{ fontSize:14, color:G.g900, lineHeight:1.6 }}>{s}</span>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* MODALITES panel */}
      {tab === "modalites" && (
        <div>
          <h2 style={{ fontFamily:"'Playfair Display',serif", fontSize:"1.8rem", fontWeight:700, marginBottom:6, color:G.g900 }}>Modalités de formation</h2>
          <p style={{ color:G.g700, marginBottom:28, fontSize:15 }}>Tout ce que vous devez savoir avant de vous inscrire</p>
          <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit,minmax(220px,1fr))", gap:14 }}>
            {[
              { icon:"💻", label:"Mode", value:"En ligne via Zoom", detail:"Accès depuis n'importe où en Afrique" },
              { icon:"⏰", label:"Durée", value:"40 heures — 2 mois", detail:"2 sessions/semaine · Mardi & Vendredi · 20h–22h GMT" },
              { icon:"💷", label:"Tarif", value:"84 000 FCFA", detail:"Paiement possible en 2 tranches (42 000 × 2)" },
            ].map((d,i) => (
              <div key={i} style={{ background:"#fff", border:"1px solid #E4E4E0", borderRadius:14, padding:"20px" }}>
                <div style={{ fontSize:26, marginBottom:10 }}>{d.icon}</div>
                <div style={{ fontSize:11, color:G.gray6, marginBottom:4, textTransform:"uppercase", letterSpacing:"0.5px" }}>{d.label}</div>
                <div style={{ fontSize:14, fontWeight:700, color:G.g800, marginBottom:4 }}>{d.value}</div>
                <div style={{ fontSize:12, color:G.gray6, lineHeight:1.5 }}>{d.detail}</div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}

